module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DEDICATION AND SPECIAL ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I would like to dedicate this and all my work to the Creator, Who teaches us to look upon trials and tribulations not as the sum total of punishment, but as the fire that hones to allow growth and subsequent rebirth. It is not about punishment, but about love, peace, learning, abundance, and grace. The light provides good things, always. So if it ain’t good, needless to say, let’s not blame the Creator. Knowing that there is redemption, and more to this life than meets the naked human eye, is a matter of faith in the promise that we are all God’s children. To that end, bring positive energy into your consciousness and may it also provide you with comfort, abundance, inspiration, and renewed purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("We dwell in the midst of infinite abundance; all else is illusion. The Creator provides for all our needs, and wants us to live in radiant health, with positive purpose and the blessings of enriched, fruitful relationships, uplifted spirits, and plentiful resources. That is the Divine plan. That is the Divine promise. Believe it.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Loving acknowledgment goes to: Manie Barron, always; Monique Patterson, forever; Amanda Maxwell; Harriett Seltzer; Monica Peters; Liza, my sister; Althea, who sees the divine; Hilary Beard, my soul sister; Joanne White, Bill Harvey, and Dr. Xu, for your depth of knowledge and understanding; Derrick, Jermaine, Dame, Virg, and the squad of RBG, for your music; Michael Storrings, for his fabulous designs; Eric Battle, Vince Natale, and Chris Bonelli, for your art; Tony Nottingham and Charles Holmes—thanks for getting my paper straight, brothers! To my husband, children, and my spiritual crew of friends, extended family, sister/brother authors, and guides . . . my village, my compound, and the very foundation of my soul—thank you!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0